export const AREAS = Object.freeze({
  TOKYO: "東京",
  KANAGAWA: "神奈川",
  CHIBA: "千葉",
  KYOTO: "京都",
  FUKUOKA: "福岡",
  NAGOYA: "名古屋",
  SENDAI: "仙台",
  SAPPORO: "札幌",
  ONLINE: "オンライン",
})

export const AREAS_ARRAY = Object.values(AREAS)

export const COURSES = Object.freeze({
  WEB: "Webサービス",
  GAME: "Gameアプリ",
  IPHONE: "iPhoneアプリ",
  WEBEXPERT: "WebExpert",
  VIDEOEDITOR: "VideoEditor",
  UIUX: "UIUX",
  PYTHON: "Python",
  AI: "AI",
})

export const COURSES_ARRAY = Object.values(COURSES)

export const SKILLS = Object.freeze({
  SWIFT: "Swift",
  CSHARP: "C#",
  HTML: "HTML",
  CSS: "CSS",
  RUBY_ON_RAILS: "Ruby on Rails",
  JAVASCRIPT: "JavaScript",
  FIGMA: "Figma",
  PREMIERE_PRO: "Premiere Pro",
  DAVINCI_RESOLVE: "DaVinci Resolve",
})

export const GRADES_ARRAY = ["1", "2", "3", "4", "M1", "M2"]

export const EXPERIENCE_PERIODS_ARRAY = [
  "1ヶ月",
  "2ヶ月",
  "3ヶ月",
  "3 ~ 6ヶ月",
  "6ヶ月 ~ 1年",
  "1年以上",
]
